module.exports = __webpack_public_path__ + "static/media/kjerne-min.511cd239.png";